import type {FC} from 'react';

import styled from 'styled-components';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props, StyledProps} from './types';

import {Container, ErrorText, TextInputLikeText, web} from './styles';

const StyledTextInputLikeView = styled.div<StyledProps>`
  ${web}
`;

const TextInputLikeView: FC<WithDomStyleProp<Props>> = ({
  children,
  disabled,
  error,
  testID,
  ...rest
}) => {
  return (
    <Container>
      <StyledTextInputLikeView
        {...rest}
        data-test-id={testID}
        disabled={disabled}
        error={error}
      >
        {children}
        {typeof error === 'string' ? (
          <ErrorText disabled={disabled}>{error}</ErrorText>
        ) : null}
      </StyledTextInputLikeView>
    </Container>
  );
};

export {TextInputLikeText, TextInputLikeView};
